<template>
    <div class="container ">

        <h1 class="text text__title">Batería de iconos</h1>
        <hr />
        <div class="d-flex">
            <div class="glyph fs1" v-for="(icon, i) in icons" :key="i">
                <div class="clearfix bshadow0 pbs">
                    <span :class="innerNameIcon(icon.icon.tags[0])" @click="onCopy(innerNameIcon(icon.icon.tags[0]))">
                        <span  v-for="(path, i) in icon.icon.paths" :key="i" :class="'path' + (i + 1)"></span>
                    </span>
                </div>
            </div>
            <div class="col-xs-12">
                <input type="text" id="copied" v-model="copie" /> 
            </div>
        </div>
    </div>
</template>

<script>
    import VueClipboard from 'vue-clipboard2'
    import json from '@/assets/icomoon/selection.json'
    
    export default {
        name: 'icons',
        data () {
            return {
                copie: null,
                icons: json.icons
            }
        },
        methods: {
            onCopy (e) {
                this.copie = e
                setTimeout(() => {
                    let copyText = document.getElementById("copied")
                    copyText.select()
                    document.execCommand("copy");
                    this.$message({
                        showClose: true,
                        message: 'Icono copiado',
                        type: 'success'
                    });
                }, 100);


            },
            onError: function (e) {
                //alert('Failed to copy texts')
            },
            innerNameIcon(string){
                return 'icon-' + string.split(' ').join('-')
            }
        }
    }
</script>

<style scoped>
    .d-flex{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-flow: row wrap;
    }
    h1 {
        font-size: 1.5em;
        font-weight: normal;
    }
    small {
        font-size: .66666667em;
    }
    a {
        color: #e74c3c;
        text-decoration: none;
    }
    a:hover, a:focus {
        box-shadow: 0 1px #e74c3c;
    }
    .bshadow0, input {
        box-shadow: inset 0 -2px #e7e7e7;
    }
    input:hover {
        box-shadow: inset 0 -2px #ccc;
    }
    input, fieldset {
        font-family: sans-serif;
        font-size: 1em;
        margin: 0;
        padding: 0;
        border: 0;
    }
    input {
        color: inherit;
        line-height: 1.5;
        height: 1.5em;
        padding: .25em 0;
    }
    input:focus {
        outline: none;
        box-shadow: inset 0 -2px #449fdb;
    }
    .glyph {
        font-size: 16px;
        width: 3em;
        padding-bottom: 1em;
        margin-bottom: 1em;
        overflow: hidden;
        text-align: center;
    }
    .liga {
        width: 80%;
        width: calc(100% - 2.5em);
    }
    .talign-right {
        text-align: right;
    }
    .talign-center {
        text-align: center;
    }
    .bgc1 {
        background: #f1f1f1;
    }
    .fgc1 {
        color: #999;
    }
    .fgc0 {
        color: #000;
    }
    p {
    margin-top: 1em;
    margin-bottom: 1em;
    }
    .mvm {
        margin-top: .75em;
        margin-bottom: .75em;
    }
    .mtn {
        margin-top: 0;
    }
    .mtl, .mal {
        margin-top: 1.5em;
    }
    .mbl, .mal {
        margin-bottom: 1.5em;
    }
    .mal, .mhl {
        margin-left: 1.5em;
        margin-right: 1.5em;
    }
    .mhmm {
        margin-left: 1em;
        margin-right: 1em;
    }
    .mls {
        margin-left: .25em;
    }
    .ptl {
        padding-top: 1.5em;
    }
    .pbs, .pvs {
        padding-bottom: .25em;
    }
    .pvs, .pts {
        padding-top: .25em;
    }
    .unit {
        float: left;
    }
    .unitRight {
        float: right;
    }
    .size1of2 {
        width: 50%;
    }
    .size1of1 {
        width: 100%;
    }
    .clearfix:before, .clearfix:after {
        content: " ";
        display: table;
    }
    .clearfix:after {
        clear: both;
    }
    .hidden-true {
        display: none;
    }
    .textbox0 {
        width: 3em;
        background: #f1f1f1;
        padding: .25em .5em;
        line-height: 1.5;
        height: 1.5em;
    }
    #testDrive {
        display: block;
        padding-top: 24px;
        line-height: 1.5;
    }
    .fs0 {
        font-size: 16px;
    }
    .fs1 {
        font-size: 32px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/icons.vue